<template>
    <div class="home_09m">
        <banner></banner>
        <br>
        <video width="100%"  controls="controls" autoplay muted>
            <source :src="`${baseUrl}img/video/video5.mp4`" type="video/mp4" />
        </video>
        <homeType text="誉诚防护" top="3" bottom="3"></homeType>
        <homeText fontSize="0.8" top="0" bottom="5" :text="$t('text1')"></homeText>
        <homeType text="热门产品" top="3" bottom="3"></homeType>
        <HotProducts></HotProducts>
        <homeType text="誉诚数据" top="5" bottom="3"></homeType>        
        <YuChenData></YuChenData>
        <YuChenProduct></YuChenProduct>
        <homeType text="快速链接" top="3" bottom="3"></homeType>
        <fastLink></fastLink>
        <homeType text="我们的工厂" top="3" bottom="3"></homeType>
        <bannerHome></bannerHome>
        <!-- <div class="factory">
            <img width="100%" src="../../public/img/09m/home/工厂图.jpg" alt="" srcset="">
        </div>    -->
        <homeType text="新闻中心" top="3" bottom="3"></homeType>
        <newsbanner09m></newsbanner09m>
        <foot09></foot09>
    </div>
</template>
<script>
import banner from '../components/banner_09m.vue'
import bannerHome from '../components/banner_home.vue'
import HotProducts from '../components/HotProducts.vue'
import homeType from '../components/homeType.vue'
import homeText from '../components/homeText.vue'
import YuChenData from '../components/data_09m.vue'
import YuChenProduct from '../components/YuChenProduct.vue'
import newsbanner09m from '../components/news_banner_09m.vue'
import foot09 from '../components/foot.vue'
import fastLink from '../components/fastLink.vue'

export default {
    components:{
        banner,HotProducts,homeType,homeText,YuChenData,YuChenProduct,newsbanner09m,foot09,fastLink,bannerHome
    },
    data() {
        return {
            text1:"",
            baseUrl:process.env.BASE_URL, 
        }
    },
}
</script>
<style lang="less" scoped>
.home_09m{
    .factory{
        width: 100%;
    }
}
</style>
<i18n>
{
  "en": {
    "text1":"Yucheng is a company dedicated to the production of various non-woven protective products. Products are widely used in medical and health, pharmaceuticals, hospitals, electronics, food, household, outdoor beauty and other related fields. The main products include high-end SMS, breathable membranes, heat-sealed protective clothing, non-woven masks, hats, work clothes, laboratory clothing and other protective clothing series with an annual production volume of 9 million pieces, non-woven clothing series with an annual production volume of 5 million pieces, non-woven fabrics The annual output of hat series is 9 million pieces, the annual output of non-woven shoe covers series is 8 million pieces, and the annual output of other products reaches 6 million pieces."
  },
  "zh": {
      "text1":"誉诚是一家致力于生产各类无纺布防护用品的公司，产品广泛用于医疗卫生、制药、医院、电子、食品、家居、户外美容和其他相关领域。主要产品包括高端SMS、透气膜、热封条防护服、无纺布口罩、帽子、工作服、实验服等防护服系列年生产量达到900万件、无纺布衣服系列年生产量500万件、无纺布帽子系列年生产量900万只、无纺布鞋套系列年生产量800万只、其他产品年生产量达到600万件。"
    }
}
</i18n>
